<template>
  <v-tooltip :location="location" :max-width="maxWidth">
    <template v-slot:activator="{ props }">
      <v-icon v-bind="props" :size="size" :color="color" :class="iconClass">
        mdi-information-outline
      </v-icon>
    </template>
    <div class="tooltip-content">
      <slot>
        <div>{{ text }}</div>
      </slot>
    </div>
  </v-tooltip>
</template>

<script>
// Presentational info icon + tooltip used in form field labels, section
// headers and table headers. Renders identical markup to the inline blocks it
// replaces; every prop defaults to the original UserGroupDetail usage so that
// call site renders exactly as before. Rich content (line breaks, conditional
// spans) can be passed through the default slot instead of `text`.
export default {
  name: "InfoTooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
    size: {
      type: [String, Number],
      default: 16,
    },
    color: {
      type: String,
      default: undefined,
    },
    iconClass: {
      type: String,
      default: "info-icon",
    },
    location: {
      type: String,
      default: "top start",
    },
    maxWidth: {
      type: [String, Number],
      default: 300,
    },
  },
};
</script>

<style scoped>
/* The admin list views styled their inline help icons via per-view scoped
   .help-icon rules; those rules cannot reach inside this component, so the
   same declarations live here. `help-icon-accent` reproduces the blue hover
   color that ModelQuickReply / ShortcutMenu / SetupGroupModel add on top of
   the base ModelQuickGroup styling. */
.help-icon {
  cursor: help;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.help-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

.help-icon-accent:hover {
  color: #1976d2 !important;
}
</style>
